import { createContext } from "react";

/** Key the old gatsby-plugin-react-i18next wrote; it is already in returning
    visitors' browsers, so it must never be renamed. */
export const LANGUAGE_KEY = "gatsby-i18next-language";

export const LANGUAGES = ["en", "pt"];
export const DEFAULT_LANGUAGE = "en";

export interface I18nPageContext {
  language: string;
  languages: string[];
  defaultLanguage: string;
  /** True when the language is explicit in the URL (/pt/...). */
  routed: boolean;
  originalPath: string;
  path: string;
}

export const DEFAULT_I18N_CONTEXT: I18nPageContext = {
  language: DEFAULT_LANGUAGE,
  languages: LANGUAGES,
  defaultLanguage: DEFAULT_LANGUAGE,
  routed: false,
  originalPath: "/",
  path: "/",
};

export const I18nContext = createContext<I18nPageContext>(DEFAULT_I18N_CONTEXT);
